module.exports = __webpack_public_path__ + "static/flags/BG-7f4e868218c2487a74c2e29aa3e0c052.gif";